import { createAction, props } from '@ngrx/store';
import { Shop } from '@us/web/shared/data-access';

export const loadShop = createAction('[Shop/API] Load Shop', props<{ shopId?: string }>());

export const loadShopSuccess = createAction('[Shop/API] Load Shop Success', props<{ shop: Shop }>());

export const loadShopFailure = createAction('[Shop/API] Load Shop Failure', props<{ error: never }>());
